// frontend/src/components/games/sudoku/SudokuNumberPad.tsx

import { SudokuCell } from '../../../hooks/games/useSudokuGame';

interface SudokuNumberPadProps {
  cells: SudokuCell[][];
  onInput: (digit: number) => void;
  onErase: () => void;
}

function countCorrectPlacements(cells: SudokuCell[][], digit: number): number {
  let count = 0;
  for (const row of cells) {
    for (const cell of row) {
      if (cell.value === digit && !cell.isError) count++;
    }
  }
  return count;
}

export function SudokuNumberPad({ cells, onInput, onErase }: SudokuNumberPadProps) {
  return (
    <div className="sudoku-number-pad">
      {Array.from({ length: 9 }, (_, i) => i + 1).map((digit) => {
        const isDone = countCorrectPlacements(cells, digit) >= 9;
        return (
          <button
            key={digit}
            type="button"
            className="sudoku-number-btn"
            onClick={() => onInput(digit)}
            disabled={isDone}
          >
            {digit}
          </button>
        );
      })}
      <button type="button" className="sudoku-number-btn erase" onClick={onErase}>
        ⌫
      </button>
    </div>
  );
}
